import Api from "api";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setDialog, setLoading } from "slices/appSlice";
import { formErrorStrfromObj } from "utils/shared";

export default function useFetchHPClients() {
  const dispatch = useDispatch();
  const [hpClients, setHpClients] = useState([]);

  const fetchHPClients = useCallback(async () => {
    try {
      dispatch(setLoading(true));
      const response = await Api.healthPlanList.listHealthPlans();
      if (response.status === 200 && response.data.length > 0) {
        setHpClients(response.data);
      } else if (response.data.length < 1) {
        dispatch(
          setDialog({
            message: "API returned an empty list of health plans",
            title: "Error",
          })
        );
      }
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  }, [dispatch]);

  useEffect(() => {
    fetchHPClients();
  }, [fetchHPClients]);
  return [hpClients, fetchHPClients];
}
